	export enum ClaimUnbundleCodeActionEnum {
		Swap = 1,
		Add = 2,
		ChangePrice = 3
	}
